
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 79 78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.267 55.933l27.716-27.716-3.066-3.067-24.65 24.65-12.35-12.35-3.067 3.067 15.417 15.416zM39.514 78c-5.393 0-10.463-1.023-15.21-3.07-4.748-2.047-8.878-4.825-12.39-8.333-3.512-3.509-6.292-7.635-8.341-12.378C1.524 49.476.5 44.407.5 39.014c0-5.393 1.023-10.463 3.07-15.21 2.047-4.748 4.825-8.878 8.333-12.39 3.509-3.512 7.635-6.292 12.378-8.341C29.024 1.024 34.093 0 39.486 0c5.393 0 10.463 1.023 15.21 3.07 4.748 2.047 8.878 4.825 12.39 8.333 3.512 3.509 6.292 7.635 8.341 12.378 2.049 4.743 3.073 9.812 3.073 15.205 0 5.393-1.023 10.463-3.07 15.21-2.047 4.748-4.825 8.878-8.333 12.39-3.509 3.512-7.635 6.292-12.378 8.341C49.976 76.976 44.907 78 39.514 78zm-.014-4.333c9.678 0 17.875-3.359 24.592-10.075C70.808 56.875 74.167 48.678 74.167 39c0-9.678-3.359-17.875-10.075-24.592C57.375 7.692 49.178 4.333 39.5 4.333c-9.678 0-17.875 3.359-24.592 10.075C8.192 21.125 4.833 29.322 4.833 39c0 9.678 3.359 17.875 10.075 24.592 6.717 6.716 14.914 10.075 24.592 10.075z","fill":"#31A44C"}})])
          )
        }
      }
    